import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ReportTaskDetailComponent } from "./report-task-detail.component";
import { CommentModule } from "src/app/app/_component/comment/comment.module";
import { SelectButtonsModule } from "src/app/app/_component/select-buttons/select-buttons.module";
import { UserWithAvatarModule } from "src/app/app/_component/user-with-avatar/user-with-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { ApiNotFoundComponentModule } from "src/app/app/_component/api-not-found/api-not-found.component.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SelectButtonsModule,
    UserWithAvatarModule,
    CommentModule,
    ApiNotFoundComponentModule,
  ],
  declarations: [ReportTaskDetailComponent],
  exports: [ReportTaskDetailComponent],
})
export class ReportTaskDetailComponentModule {}
